'use client';

import React from 'react';
import { useRole } from '@/context/RoleContext';
import AppLayout from '@/components/AppLayout';
import TimeClockHeader from './components/TimeClockHeader';
import LiveClockedInPanel from './components/LiveClockedInPanel';
import TimesheetFilters from './components/TimesheetFilters';
import TimesheetTable from './components/TimesheetTable';
import { ShieldOff } from 'lucide-react';

function AccessDenied({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] gap-4 text-center px-6">
      <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center">
        <ShieldOff size={24} className="text-muted-foreground" />
      </div>
      <div>
        <h2 className="text-lg font-600 text-foreground mb-1">Access Restricted</h2>
        <p className="text-sm text-muted-foreground max-w-sm">{message}</p>
      </div>
    </div>
  );
}

export default function TimeClockPage() {
  const { permissions, currentUser } = useRole();

  if (!permissions.canViewTimeClock) {
    return (
      <AppLayout>
        <AccessDenied message={`Time Clock is not accessible for your role (${currentUser.roleLabel}). Please use the navigation to access your permitted areas.`} />
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-6 space-y-5">
        <TimeClockHeader />
        <LiveClockedInPanel />
        <TimesheetFilters />
        <TimesheetTable />
      </div>
    </AppLayout>
  );
}